export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: "url('/hero-brain.png')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#030303]/90 via-[#030303]/70 to-[#030303]" />
      <div className="absolute inset-0 pattern-hypnotic-radial" />
      <div className="absolute inset-0 pattern-noise opacity-50 mix-blend-overlay" />

      <div
        aria-hidden
        className="absolute right-[-25%] top-1/2 -translate-y-1/2 w-[900px] h-[900px] pattern-rings opacity-50 spin-slow rounded-full"
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 w-full pt-32 pb-24">
        <p
          data-testid="hero-overline"
          className="reveal text-[10px] uppercase tracking-[0.45em] text-[#B49A6C] mb-10 flex items-center gap-4"
        >
          <span className="h-px w-12 bg-[#B49A6C]/50" />
          Comunicación Subconsciente
        </p>

        <h1
          data-testid="hero-title"
          className="reveal reveal-delay-1 font-display font-light leading-[0.95] tracking-tight text-[#E8E5DC] text-6xl sm:text-7xl md:text-8xl lg:text-[8.5rem] max-w-5xl"
        >
          Subconscious
          <span className="block text-metal italic font-normal">Lab.</span>
        </h1>

        <div className="reveal reveal-delay-2 mt-12 max-w-xl">
          <p className="text-base sm:text-lg text-[#807C70] leading-relaxed tracking-wide font-light">
            Plataforma educativa con todo lo relacionado a la comunicación
            subconsciente.
          </p>
        </div>

        <div className="reveal reveal-delay-3 mt-14 flex">
          <a
            href="https://www.skool.com/subconscious-lab-4167/about"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-cta-primary"
            className="group relative inline-flex items-center justify-center gap-3 text-[10px] uppercase tracking-[0.35em] px-10 py-5 overflow-hidden border border-[#B49A6C]/30 hover:border-[#C9C2B0]/60 transition-colors duration-500"
            style={{
              background:
                "linear-gradient(180deg, #1A1A1A 0%, #0A0A0A 50%, #000000 100%)",
              boxShadow:
                "inset 0 1px 0 rgba(255,255,255,0.06), 0 0 24px rgba(0,0,0,0.6)",
            }}
          >
            <span
              className="relative"
              style={{
                background:
                  "linear-gradient(180deg, #F2F2F4 0%, #C9C2B0 50%, #6F6B5E 100%)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                WebkitTextFillColor: "transparent",
                color: "transparent",
              }}
            >
              Club Privado
            </span>
          </a>
        </div>

      </div>
    </section>
  );
}
